import { render, staticRenderFns } from "./CaxtonHome.vue?vue&type=template&id=1833fb50&scoped=true&"
import script from "./CaxtonHome.vue?vue&type=script&lang=js&"
export * from "./CaxtonHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1833fb50",
  null
  
)

export default component.exports